"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserGroups = exports.getScopes = exports.getClientId = exports.getUserType = exports.getStoreId = exports.getOrganisationId = exports.getUserFromToken = exports.jwt = exports.getTime = exports.permissionChecker = void 0;
var jwt_decode_1 = require("jwt-decode");
var castToString = function (value) {
    if (!value) {
        return '*';
    }
    if (typeof value === 'string') {
        return value;
    }
    return value.name;
};
var permissionToScope = function (permission, organisation, store) {
    var _a = permission.split(','), action = _a[0], resource = _a[1];
    var scope = {
        action: action,
        resource: resource,
        organisation: castToString(organisation),
        store: castToString(store),
    };
    if (scope.resource === 'settings\\organisations') {
        scope.store = '#';
        if (scope.action === 'create') {
            scope.organisation = '#';
        }
    }
    return scope;
};
var permissionChecker = function (accessToken, permission, org, store) {
    var _a;
    if (!accessToken) {
        return false;
    }
    var jwt;
    try {
        jwt = (0, jwt_decode_1.default)(accessToken);
    }
    catch (e) {
        return false;
    }
    var scope = permissionToScope(permission, org, store);
    return (((_a = jwt === null || jwt === void 0 ? void 0 : jwt.user) === null || _a === void 0 ? void 0 : _a.scope) || []).some(function (s) {
        var _a = s.split(':'), organisation = _a[0], store = _a[1], action = _a[2], resource = _a[3];
        if (scope.organisation === '#' && organisation !== scope.organisation) {
            return false;
        }
        if (organisation !== scope.organisation && organisation !== '*') {
            return false;
        }
        if (store !== scope.store && store !== '*') {
            return false;
        }
        if (resource !== scope.resource && resource !== '*') {
            return false;
        }
        return action === scope.action || action === '*';
    });
};
exports.permissionChecker = permissionChecker;
var getTime = function () {
    return Date.now() / 1000;
};
exports.getTime = getTime;
var jwt = function (accessToken) {
    if (!accessToken) {
        return;
    }
    var token = undefined;
    try {
        token = (0, jwt_decode_1.default)(accessToken);
    }
    catch (e) {
        // just catch error
    }
    if (!token) {
        return;
    }
    return token.exp > (0, exports.getTime)() ? token : undefined;
};
exports.jwt = jwt;
var getUserFromToken = function (token) {
    var _a;
    return (_a = (0, exports.jwt)(token)) === null || _a === void 0 ? void 0 : _a.user;
};
exports.getUserFromToken = getUserFromToken;
var getOrganisationId = function (token) {
    var _a;
    return (_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.organisation;
};
exports.getOrganisationId = getOrganisationId;
var getStoreId = function (token) {
    var _a;
    return (_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.store;
};
exports.getStoreId = getStoreId;
var getUserType = function (token) {
    var _a;
    return (_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.profile.type;
};
exports.getUserType = getUserType;
var getClientId = function (token) {
    var _a;
    return (_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.client_id;
};
exports.getClientId = getClientId;
var getScopes = function (token) {
    var _a;
    return ((_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.scope) || [];
};
exports.getScopes = getScopes;
var getUserGroups = function (token) {
    var _a, _b;
    return ((_b = (_a = (0, exports.getUserFromToken)(token)) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.groups) || [];
};
exports.getUserGroups = getUserGroups;
//# sourceMappingURL=auth-helpers.js.map